import React from "react";
import Icon1 from "../../assets/images/green.svg";
import Icon2 from "../../assets/images/blue.svg";
import moment from "moment/moment";
import { FaUniversity } from "react-icons/fa";
import {
  ActivityCard,
  ActivityIconCol,
  ActivityBody,
  ActivityMeta,
  ActivityDot,
  ActivityTitle,
  ActivityDesc,
  ActivityAmount,
  SterlingBadge,
} from "./style";

export const Activity = ({ data, active }) => {
  const isSterling = data.wallet === "sterling";
  return (
    <ActivityCard $isSterling={isSterling}>
      <ActivityIconCol>
        <img src={active === 1 ? Icon1 : Icon2} alt="icon" />
      </ActivityIconCol>

      <ActivityBody>
        <ActivityMeta>
          <small>{moment(data.createdAt).format("DD-MM-YYYY")}</small>
          <ActivityDot>·</ActivityDot>
          <small>{moment(data.createdAt).format("HH:mm")}</small>
          {isSterling && (
            <SterlingBadge>
              <FaUniversity size={10} /> Sterling Bank
            </SterlingBadge>
          )}
        </ActivityMeta>
        <ActivityTitle>
          {data.type === "Credit" ? "You topped up your wallet" : data.description}
        </ActivityTitle>
        <ActivityDesc>
          {data.type === "Credit"
            ? `₦${data.amount} unit equivalent was added to your wallet`
            : `You used ${data.amount} units for ${data.description}`}
        </ActivityDesc>
      </ActivityBody>

      <ActivityAmount>
        <h6 style={{ color: data.type === "Credit" ? "#5EAA42" : "#D52143" }}>
          {data.type === "Credit" ? "+" : "-"} {data.new_balance} units
        </h6>
        <p>{data.type === "Credit" ? "+" : ""} {data.amount} units</p>
      </ActivityAmount>
    </ActivityCard>
  );
};
